<template>
  <v-app>
    <AppBar />
    <v-content>
      <Content />
    </v-content>
    <v-footer color="transparent">
      <Footer />
    </v-footer>
  </v-app>
</template>

<script>
import AppBar from "./components/AppBar";
import Content from "./components/Content";
import Footer from "./components/Footer";

export default {
  name: "App",
  components: { AppBar, Content, Footer }
};
</script>
